module.exports = __webpack_public_path__ + "static/video-converter-slide-defe1d58efb63234a7b7f2a81b563047.jpg";